import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from '@app/agent/services/agent.service';
import { get } from 'lodash';
import { GenerateInvoicePDF } from '../utils/generateInvoicePdf';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-customer-invoice',
  templateUrl: './customer-invoice.component.html',
})
export class CustomerInvoiceComponent {
  public bookingInformation: any;
  public flightsResultsResponse: any;
  custItineraryId: any;
  customerDetails: any;
  agencyDetails: any;
  flightDetails: any;
  productDetails: any;
  invoiceDetails: any;
  imageData: any;
  @ViewChild('customerpdfNote') customerpdfNote: any;
  @Input() set customerInvoiceData(data: any) {
    if (data) {
      this.custItineraryId = data.Id;
      this.getCustomerInvoice(this.custItineraryId);
    }
  }

  constructor(
    private agentService: AgentService,
    private route: Router,
    private datePipe: DatePipe,
    private generateCustomerInvoice: GenerateInvoicePDF
  ) {
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  getCustomerInvoice(itineraryId: any) {
    let data = {
      reference: itineraryId,
    };
    this.agentService.getCustomerInvoiceData(data).subscribe((response: any) => {
      if (response) {
        let blob = new Blob([response], { type: 'application/pdf' });
        let pdfUrl = window.URL.createObjectURL(blob);

        var PDF_link = document.createElement('a');
        PDF_link.href = pdfUrl;
        // TO OPEN PDF ON BROWSER IN NEW TAB
        window.open(pdfUrl, '_blank');
        // TO DOWNLOAD PDF TO YOUR COMPUTER
        PDF_link.download = 'Customer-Invoice.pdf';
        PDF_link.click();

        // this.customerDetails = data.data;
        // this.agencyDetails = get(this.customerDetails, 'agency', {});
        // this.invoiceDetails = get(this.customerDetails, 'invoice', {});
        // this.productDetails = get(this.customerDetails, 'product_deatails', {});
        // this.flightDetails = get(this.customerDetails, 'product_deatails.flight_details', {});
        // setTimeout(() => {
        //   this.generatePdf();
        // }, 500);
      }
    });
  }

}
